<template>
  <div>
    <div>
      <base-input alternative="" label="Select F&B POS Setup Mode" input-classes="form-control"
        style="margin-top: 8px; margin-left: 22px;">
        <b-row>
          <b-col>
            <a-radio-group v-model="menus.setupMode" button-style="solid" @change="onModeChange">
              <a-radio-button value="fineDining">Fine Dining</a-radio-button>
              <a-radio-button value="fastFood">Fast Food</a-radio-button>
            </a-radio-group>
          </b-col>
        </b-row>
      </base-input>
      <base-checkbox class="mb-3" v-model="menus.requireGuestEntry" style="margin-top: 8px; margin-left: 22px;">
        Require Guest Entry
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.requireTransactionTypeEntry" style="margin-top: 8px; margin-left: 22px;">
        Require Transaction Type Entry
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.enableTableManagement" style="margin-top: 8px; margin-left: 22px;">
        Enable Table Management
      </base-checkbox>
      <base-checkbox class="mb-3 ml-6" v-model="menus.requireTableEntry" style="margin-top: 8px; margin-left: 22px;" v-if="menus.enableTableManagement">
        Require Table Entry
      </base-checkbox>
      <base-checkbox class="mb-3 ml-6" v-model="menus.enableAutoDisplayTableLookupWindow" style="margin-top: 8px; margin-left: 22px;" v-if="menus.enableTableManagement">
        Auto Display of Table Lookup Window<br>(auto prompt of table selection when choosing Dine In as transaction type)
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.enableEarlyBillOut" style="margin-top: 8px; margin-left: 22px;">
        Enable Early Bill Out
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.enableDisplayOrderStatus" style="margin-top: 8px; margin-left: 22px;">
        Enable Display of Order Status
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.enablePaymentWithoutPrepare" style="margin-top: 8px; margin-left: 22px;">
        Enable Payment Without Prepare Function
      </base-checkbox>
      <base-checkbox class="mb-3" v-model="menus.hidePrepareButton" style="margin-top: 8px; margin-left: 22px;">
        Hide Prepare Button
      </base-checkbox>
      <base-input label="Max Order Serve Delay Time (in minutes)" placeholder="" input-classes="form-control" type="number" v-model="menus.maxOrderServeDelayTime" style="margin-top: 8px; margin-left: 22px;" />
    </div>
  </div>

</template>

<script>
import { forEach } from 'core-js/fn/dict';
import { mapState } from 'vuex'

let component_x;
export default {
  computed: {
    ...mapState(['endPoint', 'profileId']),
  },
  mounted: async function () {
    component_x = this;

    if (this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null) {
      this.menus = this.$attrs.defaultValue
      this.isNewSetting = false
    } else {
      this.menus = {
        setupMode: "fineDining",
        requireGuestEntry: true,
        requireTransactionTypeEntry: true,
        enableTableManagement: true,
        requireTableEntry: true,
        enableAutoDisplayTableLookupWindow: false,
        enableEarlyBillOut: false,
        enableDisplayOrderStatus: false,
        enablePaymentWithoutPrepare: false,
        hidePrepareButton: false,
        maxOrderServeDelayTime: 20
      }
    }
    this.settingCode = this.$attrs.settingCode
  },
  watch: {
    menus: {
      handler: async function () {
        var configValues = {}
        forEach(this.menus, function (value, key) {
          configValues[key] = value
        })
        configValues[this.settingCode] = this.menus
        component_x.$emit("changeValue", configValues)

        if (this.menus.enableTableManagement === false) {
          this.menus.requireTableEntry = false
          this.menus.enableAutoDisplayTableLookupWindow = false
        }
      },
      deep: true
    },

  },
  data() {
    return {
      menus: {},
      settingCode: null,
    }
  },
  methods: {
    onModeChange(e) {
      switch (e.target.value) {
        case "fineDining":
          Object.assign(this.menus, {
            requireGuestEntry: true,
            requireTransactionTypeEntry: true,
            enableTableManagement: true,
            requireTableEntry: true,
            enableAutoDisplayTableLookupWindow: false,
            enableEarlyBillOut: false,
            enableDisplayOrderStatus: false,
            enablePaymentWithoutPrepare: false,
            hidePrepareButton: false
          })
          break;

        case "fastFood":
          Object.assign(this.menus, {
            requireGuestEntry: false,
            requireTransactionTypeEntry: true,
            enableTableManagement: false,
            requireTableEntry: false,
            enableAutoDisplayTableLookupWindow: false,
            enableEarlyBillOut: false,
            enableDisplayOrderStatus: false,
            enablePaymentWithoutPrepare: true,
            hidePrepareButton: true
          })
          break;
      
        default:
          break;
      } 
    }
  }
}
</script>
